module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAOBAMAAAC88gOBAAAAAXNSR0IArs4c6QAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9kKFhU1MFgiZCQAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAFVBMVEX4+MiAeHCIaDDgwGj4+Hj4+Pj///83RZ0JAAAAAXRSTlMAQObYZgAAAAFiS0dEBmFmuH0AAABsSURBVAjXZc6xDQJRDARRC9HAauUcQQUf4xwJGpjA/bdCcBdwMNm+aOP8PvSMVx16RP0UNR5qTKcZKlqQKegE0tEWnd6hHZ0MbeicDQQ75AaGzC9YI1qjJMXgKFnL8tKypPo/djvue5yuhy4fxfIr3yl77g4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/types/Ground.png
// module id = 167
// module chunks = 0